const escapeIcsText = (value) => {
  if (!value) return '';
  return String(value)
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/\r/g, '')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;');
};

const toIcsDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
};

export const createReservaIcs = (reserva) => {
  const start = toIcsDate(reserva?.fecha_hora_inicio);
  if (!start) return null;

  const end = toIcsDate(reserva?.fecha_hora_fin) || toIcsDate(new Date(new Date(reserva.fecha_hora_inicio).getTime() + 60 * 60 * 1000));

  const origenDir = reserva?.origen_direccion || reserva?.origen_codigo_postal || 'N/A';
  const destinoDir = reserva?.destino_direccion || reserva?.destino_codigo_postal || 'N/A';
  const clienteNombre = `${reserva?.cliente_nombre || ''} ${reserva?.cliente_apellidos || ''}`.trim();
  const clienteEmail = reserva?.cliente_email || 'N/A';
  const clienteTelefono = reserva?.cliente_telefono || 'N/A';
  const precioReserva = typeof reserva?.precio === 'number' ? `${reserva.precio.toFixed(2)}€` : 'N/A';
  const distanciaKm = typeof reserva?.distancia_km === 'number' ? `${reserva.distancia_km.toFixed(2)} km` : 'N/A';

  const summary = `Reserva ${reserva?.id || ''} - ${clienteNombre || 'Cliente'}`.trim();
  const descriptionLines = [
    `Cliente: ${clienteNombre || 'N/A'}`,
    `Email: ${clienteEmail}`,
    `Teléfono: ${clienteTelefono}`,
    `Origen: ${origenDir}`,
    `Destino: ${destinoDir}`,
    `Precio aprox.: ${precioReserva}`,
    `Distancia: ${distanciaKm}`,
    `Estado: ${reserva?.estado || 'N/A'} / ${reserva?.sub_estado || 'N/A'}`,
  ];

  const uid = `reserva-${reserva?.id || 'sin-id'}@overtaxi.es`;
  const location = `${origenDir} → ${destinoDir}`;

  const content = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//OverTaxi//Reservas//ES',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${escapeIcsText(uid)}`,
    `DTSTAMP:${toIcsDate(new Date())}`,
    `DTSTART:${start}`,
    `DTEND:${end || start}`,
    `SUMMARY:${escapeIcsText(summary)}`,
    `LOCATION:${escapeIcsText(location)}`,
    `DESCRIPTION:${escapeIcsText(descriptionLines.join('\n'))}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n');

  return {
    content,
    filename: `reserva_${reserva?.id || 'sin-id'}.ics`,
  };
};

export const downloadIcsFile = (content, filename) => {
  const blob = new Blob([content], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
